<template>
  <div class="pay_stay">
    <div class="box">
      <span class="title_head">{{ title }}</span>
      <span class="price"><span class="font_big">{{ price }}</span>元</span>
      <span class="validate">有效期：{{ textCountDown }}</span>
      <div class="button_list">
        <div :class="['button', 'no_use']" @click="clickNoUse">我不需要</div>
        <div :class="['button', 'use']" @click="clickUse">{{ textButtonUse }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { dialogStayType } from '@/common/const.js'
import api from '@/api'
export default {
  props: {
    type: {
      type: Number,
      default: dialogStayType.login
    }
  },

  data () {
    return {
      textCountDown: '',
      timeDiff: 0,
      interval: null,
      title: '',
      price: '',
      textButtonUse: ''
    }
  },

  computed: {
    isDubaVip () {
      return this.$store.state.isDubaVip
    },
  },

  mounted () {
    this.initTextButtonUse()
    this.initTile()
    this.initPrice()
    this.initInterval()
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods: {
    clickNoUse () {
      this.$emit('clickNoUse')
    },

    clickUse () {
      this.$emit('clickUse')
    },

    initTextButtonUse () {
      if (this.type === dialogStayType.login) {
        this.textButtonUse = '登录领取'
      }

      if (this.type === dialogStayType.pay) {
        this.textButtonUse = '立即使用'
      }
    },

    initTile () {
      if (this.type === dialogStayType.login) {
        if (this.isDubaVip) {
          this.title = '您获得毒霸会员专属红包'
        } else {
          this.title = '您获得金秋限时红包'
        }
      }

      if (this.type === dialogStayType.pay) {
        if (this.isDubaVip) {
          this.title = '您的专属红包即将过期'
        } else {
          this.title = '您的金秋红包即将过期'
        }
      }
    },

    initPrice () {
      if (this.isDubaVip) {
        this.price = '100'
      } else {
        this.price = '40'
      }
    },

    async initInterval () {
      const now = await this.getServiceTime()
      const todayEnd = new Date(now).setHours(23, 59, 59, 999)
      this.timeDiff = todayEnd - now
      this.updateTextCountDown(this.timeDiff)
      this.interval = setInterval(() => {
        this.timeDiff -= 1000
        if (this.timeDiff < 0) {
          this.timeDiff = 24 * 60 * 60 * 1000 + this.timeDiff
        }
        this.updateTextCountDown(this.timeDiff)
      }, 1000)
    },

    getServiceTime () {
      return api.common.getServiceTime().then(res => res?.data?.timestamp * 1000)
    },

    updateTextCountDown (timeDiff) {
      const date = this.timeDiff
      const hours = parseInt(date / (1000 * 60 * 60))
      const minutes = parseInt((date % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = parseInt((date % (1000 * 60)) / 1000)
      const strHours = hours < 10 ? ('0' + hours) : hours
      const strMinutes = minutes < 10 ? ('0' + minutes) : minutes
      const strSeconds = seconds < 10 ? ('0' + seconds) : seconds
      this.textCountDown = `${strHours}:${strMinutes}:${strSeconds}`
    }
  },
}
</script>

<style lang="scss" scoped>
.pay_stay { position: absolute; top: 0; left: 0; display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; background: rgba($color:#000000, $alpha:0.5);
  .box { display: flex; flex-direction: column; align-items: center; width: 380px; height: 424px; color: #FFF193; background-image: url(~@/assets/images/bg_stay_red_package.png);
    .title_head { margin-top: 78px; font-size: 22px; font-weight: 400; }
    .price { margin-top: 122px; font-weight: 600;
      .font_big { font-size: 48px; }
    }
    .validate { display: inline-block; width: 97px; font-size: 12px; }
    .button_list { display: flex; justify-content: center;
      .button { display: flex; align-items: center; justify-content: center; width: 94px; height: 30px; margin-top: 21px; font-size: 15px; font-weight: 400; cursor: pointer; border: 1px solid #FEED57; border-radius: 15px;
        &.no_use:hover { color: #FFF6A8; }
        &.use { margin-left: 20px; color: #E10C00; background: linear-gradient(0deg, #F99C00, #FEED4D, #FEEC80);
          &:hover { color: #FF0E01; background: linear-gradient(0deg, #FFCD35, #FFF170, #FFF19E); }
        }
      }
    }
  }
}
</style>
